import { Injectable } from '@angular/core';
import { LoaderService } from '../loader.service';

import { MarcaModelo } from '@tivic-team/manager-ts/dist/fta';
import { MarcaModeloSearch } from 'app/services/fta/marca-modelo.search';
import { MarcaModeloController } from 'app/controllers/fta/marca-modelo.controller';

@Injectable()
export class MarcaModeloService {

  constructor(
    private _marcaModeloController: MarcaModeloController,
    private _loaderService: LoaderService
  ) {}

  async find (marcaModeloSearch?:MarcaModeloSearch, isLoading:boolean=true):Promise<MarcaModelo[]>{
    try{
      if(isLoading) this._loaderService.show();
      return await this._marcaModeloController.find(marcaModeloSearch && marcaModeloSearch.getFilters() || null).finally(() => 
      {if (isLoading) this._loaderService.hide()});
    }catch(error){
      this._loaderService.hide();
      console.log(error);
      return [];
    }
    
  }  

  async get(cdMarca:number):Promise<MarcaModelo>{
    this._loaderService.show();
    return this._marcaModeloController.get(cdMarca).finally(() => this._loaderService.hide());
}

  async sync():Promise<JSON>{
    this._loaderService.show();
    return this._marcaModeloController.sync().finally(() => this._loaderService.hide());
  }
}
